module.exports = __webpack_public_path__ + "img/Firm.3d548c6b.png";